import React from 'react';
import getWeeks from './getWeeks';
import { areRangesOverlapping } from 'date-fns';
import CalendarLayout from '../Layout';

const CalendarCore = ({ period, setPeriod, events }) => {
  const { year, month } = period;
  const { weeks, days } = getWeeks({ year, month });
  const monthEvents = events.filter(event => {
    const eventStartDate = new Date(event.start_date);
    const eventEndDate = new Date(event.end_date);
    return areRangesOverlapping(
      eventStartDate,
      eventEndDate,
      days[0],
      days[days.length - 1],
    );
  });
  return (
    <CalendarLayout
      setPeriod={setPeriod}
      month={month}
      year={year}
      weeks={weeks}
      events={monthEvents}
    />
  );
};

CalendarCore.propTypes = {};

export default CalendarCore;
